import React, { useContext } from "react";
import { Col } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import InputError from "./InputError";
import InputTitle from "./InputTitle";
import CreatableSelect from "react-select/creatable";
import { isInputHasLocale } from "helpers/forms";
import { Context } from "components/Form";
import { getId } from "helpers/functions";

const CreatableReactSelect = ({
  control: controlOverride,
  errors: errorsOverride,
  name,
  placeholder = "pleaseWriteSomethingAndAddThem",
  rules = { required: <FormattedMessage id="requiredField" /> },
  lg = 6,
  locale = "",
  options,
}) => {
  const { formatMessage } = useIntl();
  const { control = controlOverride, errors = errorsOverride } =
    useContext(Context);
  const handleSelectOptions = (options) => {
    if (options?.length < 0) return [];
    return options?.map((option) => {
      return {
        value: getId(option) || option?.value || option,
        label:
          option?.name?.[locale] ||
          option?.label ||
          formatMessage({ id: option }),
      };
    });
  };

  return (
    <>
      <Col lg={lg}>
        <div className={`form-group ${rules?.required ? "required" : ""}`}>
          <InputTitle name={name} locale={locale} />
          <Controller
            control={control}
            name={`${name}${isInputHasLocale(locale) ? `.${locale}` : ""}`}
            rules={rules}
            render={({ field: { onChange, value } }) => {
              const values =
                typeof value === "object"
                  ? value?.map((item) => {
                      return {
                        label: item,
                        value: item,
                      };
                    })
                  : {
                      label: value,
                      value: value,
                    };
              return (
                <CreatableSelect
                  value={values}
                  className="basic-single"
                  classNamePrefix="select"
                  isMulti
                  formatCreateLabel={(inputText) =>
                    `"${inputText}" ${formatMessage({ id: "add" })}`
                  }
                  onChange={(selectedOptions) => {
                    const selectedValuesLabels = selectedOptions?.map(
                      (selected) => {
                        return selected?.label;
                      }
                    );

                    onChange(selectedValuesLabels);
                  }}
                  placeholder={<FormattedMessage id={placeholder} />}
                  options={handleSelectOptions(options)}
                />
              );
            }}
          />

          <InputError name={name} errors={errors} locale={locale} />
        </div>
      </Col>
    </>
  );
};

export default CreatableReactSelect;
